import React from 'react';
import DestinationContainerScanPage
    from 'src/components/pages/destination-container-scan/DestinationContainerScanPageContainer';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import { ScanIcons } from 'src/constants/general-media';
import Icon from '@amzn/meridian/icon';
import arrowsUpAndDownTokens from '@amzn/meridian-tokens/base/icon/arrows-up-and-down';
import { MoveContainerMode } from 'src/models/batchMoveContainers';
import { SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import * as AppRoutes from 'src/routing/constants/routes';
import '../Sortation.scss';

interface ScanDestinationForSortDispatchProps {
    setPageToRender: (pageToRender: SortContainerPages) => void;
    selectedSortType: string;
}

type Props = ScanDestinationForSortDispatchProps;

class ScanDestinationForSort extends React.Component<Props> {

    private onBackButtonClick = () => {
        this.props.setPageToRender(SortContainerPages.SCAN_SOURCE_CONTAINER_PAGE);
    }

    public render() {
        return(
            <>
                <div className={"sortation sortation-destination-scan-container"}>
                    <BreadcrumbGroup>
                        <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                        <Breadcrumb href={AppRoutes.SUB_SORT_PAGE_ROUTE}>{AppStrings.SORT}</Breadcrumb>
                        <Breadcrumb>{this.props.selectedSortType}</Breadcrumb>
                    </BreadcrumbGroup>
                </div>
                <DestinationContainerScanPage
                    onBackButtonClick={this.onBackButtonClick}
                    pageTitle={AppStrings.SORTATION_SCAN_DESTINATION_CONTAINER_TITLE}
                    barcodeScanIcon={ScanIcons.SCAN_PALETTE_ICON}
                    barcodeScanText={AppStrings.SORTATION_SCAN_DESTINATION_CONTAINER_TEXT}
                    barcodeScanInputLabel={AppStrings.SORTATION_SCAN_DESTINATION_CONTAINER_INPUT_LABEL}
                    barcodeScanInputPlaceholder={AppStrings.SORTATION_SCAN_DESTINATION_CONTAINER_PLACEHOLDER}
                    barcodeScanButtonText={AppStrings.SORTATION_SCAN_SOURCE_CONTAINER_BUTTON}
                    barcodeScanButtonIcon={<Icon tokens={arrowsUpAndDownTokens}/>}
                    moveContainerMode={MoveContainerMode.SORT}
                    headingTestId="sort-destination-heading"
                    inputTestId="sort-destination-input"
                    buttonTestId="sort-destination-submit-button"
                />
            </>
        );
    }
}

export default ScanDestinationForSort;